<mat-dialog-content>
  <div class="course_popup_overlay width_785" roleAccessControl pageType="pathway-course">
    <div class="course_popup">
      <div class="course_title">Manage related courses {{(this.pageType() ? '- ' + this.pageType() : '')}}<a
      class="material-icons" mat-dialog-close>close</a></div>
      <div class="relate_course_scrl course_gnl">
        @if (loadPageData()) {
          <div class="m-b-16">
            @if (successOrWarnMsg()) {
              <app-success-or-warning-popup [popupType]="successOrWarnPopupType()"
              [displayText]="successOrWarnMsg()" (message)="getMessage($event)"></app-success-or-warning-popup>
            }
            @if (pageType()) {
              @if (pageType() && relatedCourseJSONDetails() && (relatedCourseRefData()|json)!=='{}') {
                <app-add-related-course [pageType]="pageType()" [buttonType]="buttonType"
                  [relatedCourseJSONDetails]="relatedCourseJSONDetails()" [relatedCourseMatData]="relatedCourseMatData"
                  [relatedCourseId]="relatedCourseId" [relatedCourseRefData]="relatedCourseRefData()"
                  [relatedCourseAjaxData]="relatedCourseAjaxData()"
                (loadRelatedCourseData)="loadRelatedCourseData($event)"></app-add-related-course>
              }
            } @else {
              @if (!totalRelatedCourseCount()) {
                <app-no-data-available [pageType]="noDataPageName" accessType="create"
                (openAddPage)="openAddRelatedCourse($event)"></app-no-data-available>
              }
              @if (relatedCourseData() && totalRelatedCourseCount()) {
                <app-related-course-listing
                  [relatedCourseMatData]="relatedCourseMatData" [relatedCourseData]="relatedCourseData()"
                  (openAddRelatedCourse)="openAddRelatedCourse($event)"
                (loadRelatedCourseData)="loadRelatedCourseData($event)"></app-related-course-listing>
              }
            }
          </div>
        }
      </div>

      <div class="course_pop_btn padd_top_32">
        @if (pageType()) {
          <div class="text_count cancel" (click)="goToListingPage()" roleAccessControl accessType="back">Back</div>
          <div class="course_btn_group">
            @if (pageType()!=='view') {
              <button class="active" (click)="getButtonType('clear')" roleAccessControl accessType="clear">Clear</button>
            }
            @if (pageType()!=='view') {
              <button mat-stroked-button (click)="getButtonType('save')"  roleAccessControl accessType="save">SAVE</button>
            }
            @if (pageType()==='view') {
              <button mat-stroked-button  mat-dialog-close roleAccessControl  roleAccessControl accessType="close">Close</button>
            }
          </div>
        } @else {
          <div class="text_count cancel" mat-dialog-close>Close</div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>